import request from '@/utils/request'

// 查询医师信息列表
export function listDoctor(query) {
  return request({
    url: '/doctor/doctor/list',
    method: 'get',
    params: query
  })
}

// 查询医师信息分页
export function pageDoctor(query) {
  return request({
    url: '/doctor/doctor/page',
    method: 'get',
    params: query
  })
}

// 查询医师信息详细
export function getDoctor(data) {
  return request({
    url: '/doctor/doctor/detail',
    method: 'get',
    params: data
  })
}

// 新增医师信息
export function addDoctor(data) {
  return request({
    url: '/doctor/doctor/add',
    method: 'post',
    data: data
  })
}

// 修改医师信息
export function updateDoctor(data) {
  return request({
    url: '/doctor/doctor/edit',
    method: 'post',
    data: data
  })
}

// 删除医师信息
export function delDoctor(data) {
  return request({
    url: '/doctor/doctor/delete',
    method: 'post',
    data: data
  })
}

export function importDoctor(data) {
  return request({
    url: '/doctor/doctor/import',
    method: 'post',
    data: data
  })
}

export function recommend(data) {
  return request({
    url: '/doctor/doctor/recommend',
    method: 'post',
    data: data
  })
}

// 设置和取消顶级医师
export function changeDoctorTopStatus (id, isTopDoctor) {
  const data = {
    id,
    isTopDoctor
  }
  return request({
    url: '/doctor/doctor/changeIsTopDoctor',
    method: 'put',
    data: data
  })
}

// 设置和取消最好医师
export function changeDoctorBestStatus (id, isBestDoctor) {
  const data = {
    id,
    isBestDoctor
  }
  return request({
    url: '/doctor/doctor/changeIsBestDoctor',
    method: 'put',
    data: data
  })
}

// 自主加减分
export function adjustDoctorScore (id, changeScore) {
  const data = {
    id,
    changeScore
  }
  return request({
    url: '/doctor/doctor/changeScore',
    method: 'put',
    data: data
  })
}

// 查询名校信息列表
export function getFamousSchoolList(query) {
  return request({
    url: '/doctor/prestigiousSchool/list',
    method: 'get',
    params: query
  })
}

// 设置或取消名校
export function setDoctorFamousSchool (id, prestigiousSchoolId) {
  const data = {
    id,
    prestigiousSchoolId
  }
  return request({
    url: '/doctor/doctor/changeIsSchool',
    method: 'put',
    data: data
  })
}

// 查询某个医生的荣誉列表
export function getDoctorHonorList(query) {
  return request({
    url: '/doctor/doctorHonor/list',
    method: 'get',
    params: query
  })
}

// 新增医师荣誉信息
export function setDoctorHonor(data) {
  return request({
    url: '/doctor/doctorHonor/barchAdd',
    method: 'post',
    data: data
  })
}

// 同步医生华歧系数
export function syncDoctorScore(data = []) {
  return request({
    url: '/doctor/doctor/syncDoctorScore',
    method: 'put',
    data: data
  })
}

// 查询某个医生的华歧系数详情
export function getDoctorScoreDetail(doctorId) {
  return request({
    url: '/doctor/doctorScoreDetail/detailByDoctorId',
    method: 'get',
    params: { doctorId: doctorId }
  })
}
